module.exports = __webpack_public_path__ + "img/31.04a50554.png";